import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link, Typography } from '@mui/material';

import ContactUsModal from 'components/Modal/modals/ContactUs';
import { Alert } from 'components';

const AccountIsNotActive = () => {
  const { t } = useTranslation();
  const [isActivatedModalOpen, setIsActivatedModalOpen] = useState(false);
  return (
    <div style={{ margin: '10px 0' }}>
      <ContactUsModal
        open={isActivatedModalOpen}
        onClose={() => setIsActivatedModalOpen(false)}
      />
      <Alert
        variant="standard"
        severity="warning"
        title={t('PAGE_LOGIN_ACCOUNT_NOT_ACTIVATED_TITLE')}
      >
        <div>
          <Trans i18nKey="PAGE_LOGIN_ACCOUNT_NOT_ACTIVATED_FULL_MESSAGE">
            <Typography component="span" variant="body2" />
            <Link
              type="button"
              component="button"
              variant="body2"
              sx={{
                cursor: 'pointer',
                display: 'contents'
              }}
              onClick={() => setIsActivatedModalOpen(true)}
            />
            <Typography component="span" variant="body2" />
          </Trans>
        </div>
      </Alert>
    </div>
  );
};

export default AccountIsNotActive;
